const firebaseConfig = {
  apiKey: "AIzaSyBuv3U7MEP4cqCwKoKjQ2JRSyvss5ULi0M",
  authDomain: "ulala-b38b0.firebaseapp.com",
  projectId: "ulala-b38b0",
  storageBucket: "ulala-b38b0.appspot.com",
  messagingSenderId: "358344082476",
  appId: "1:358344082476:web:eca6ec279b82f40f28bd89"
};

export default firebaseConfig;


  